// API Configuration
const PROD_API_URL = process.env.REACT_APP_API_URL || 'https://backend.digitalejukebox.be';
const QA_API_URL = process.env.REACT_APP_QA_API_URL || 'https://digitalejukebox-test.be';

// Get API environment from localStorage, default to 'prod'
const getStoredApiEnvironment = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('apiEnvironment') || 'prod';
  }
  return 'prod';
};

// Get the API base URL based on the stored environment
export const getApiBaseUrl = () => {
  const environment = getStoredApiEnvironment();
  return environment === 'qa' ? QA_API_URL : PROD_API_URL;
};

// Export the API base URL (dynamically determined)
export const API_BASE_URL = getApiBaseUrl();

// Set API environment
export const setApiEnvironment = (environment) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('apiEnvironment', environment);
  }
};

// Get current API environment
export const getApiEnvironment = () => {
  return getStoredApiEnvironment();
};

// You can add other configuration variables here as needed
export const API_CONFIG = {
    baseUrl: API_BASE_URL,
    // Add other API-related config here if needed
    // headers: {
    //     'Content-Type': 'application/json',
    // },
    // timeout: 30000,
}; 